module.exports = __webpack_public_path__ + "static/media/33.720ae3a9.svg";